import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";

import { ScreenContext } from "../..";

export function ScreenController({ id, style, children, ...props }) {
  const { store, dispatch } = useContext(ScreenContext);

  useEffect(() => {
    if (!(id in store.zMap))
      dispatch({ type: "init-z-index", value: { screen: id } });
  }, [id, store, dispatch]);

  return (
    <div
      {...props}
      style={{
        width: "inherit",
        height: "inherit",
        ...style,
        position: "absolute",
        zIndex: store.zMap[id]?.z,
      }}
    >
      {children}
    </div>
  );
}

ScreenController.propTypes = {
  id: PropTypes.string.isRequired,
  style: PropTypes.object,
  children: PropTypes.node,
};
ScreenController.defaultProps = {
  style: {},
  children: null,
};

export default ScreenController;
